// removed by extract-text-webpack-plugin
module.exports = {"section":"src-pages----index-module---section---l4Kpe","content":"src-pages----index-module---content---1f4nN","smallCaps":"src-pages----index-module---smallCaps---vc3eP","pointers":"src-pages----index-module---pointers---aQ5ns","icon":"src-pages----index-module---icon---1AvPU","title":"src-pages----index-module---title---1LAhw","divider":"src-pages----index-module---divider---qg2V3"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/index.module.scss
// module id = 568
// module chunks = 35783957827783